export type GenerateLinkOptions = {
	baseUrl: string;
	route: string[];
	params?: Record<string, string>;
	query?: Record<string, string | boolean | number>;
};

export function generateLink({
	baseUrl,
	route,
	params = {},
	query = {},
}: GenerateLinkOptions): string {
	let path = [
		baseUrl.replace(/\/+$/, ''),
		...route.map((r) => r.replace(/^\/+|\/+$/g, '')),
	].join('/');

	for (const key in params) {
		path = path.replace(`:${key}`, params[key]);
	}

	const queryString = Object.entries(query)
		.map(
			([key, value]) =>
				`${encodeURIComponent(key)}=${encodeURIComponent(value)}`
		)
		.join('&');

	return queryString ? `${path}?${queryString}` : path;
}

export type GeneratePathOptions = {
	route: string[];
	params?: Record<string, string>;
	query?: Record<string, string | boolean | number>;
	relativePath?: boolean;
};

export function generatePath({
	route,
	params = {},
	query = {},
	relativePath = false,
}: GeneratePathOptions): string {
	const sanitizedSegments = route.map((r) => r.replace(/^\/+|\/+$/g, ''));
	let path = (!relativePath ? '/' : '') + sanitizedSegments.join('/');

	for (const key in params) {
		path = path.replace(`:${key}`, params[key]);
	}

	const queryString = Object.entries(query)
		.map(
			([key, value]) =>
				`${encodeURIComponent(key)}=${encodeURIComponent(value)}`
		)
		.join('&');

	return queryString ? `${path}?${queryString}` : path;
}
